import React from "react";
import styles from "./HeaderLoadingSkeleton.module.scss";

const HeaderLoadingSkeleton = () => {
  return (
    <div className={styles.headerLoadingSkeleton}>
      <div>
        <div className={styles.headerLoadingText} />
      </div>
      <div className={styles.buttons}>
        <div className={styles.headerLoadingButton} />
        <div className={styles.headerLoadingButton} />
      </div>
    </div>
  );
};

export default HeaderLoadingSkeleton;
